export enum CommonUserGroups {
    ROLTEK = 'Roltek',
    ROLTEK_AT = 'Roltek AT',
}

export enum RoltekUserGroups {
    ROLTEK = 'Roltek',
    ROLTEK_AT = 'Roltek AT',
    ROLTEK_HR = 'Roltek HR',
    ROLTEK_IT = 'Roltek IT',
}
